import { isOutdated } from './utils/app-version';

window['wso'] = null;
const network = {
    wso: null,
    reconnecting: false,
    registered_rpcs: {},
    protocol: '',
    host: '',
    port: '',
    // Exponential backoff (base -> max, +jitter) instead of a fixed 1s retry -
    // a fixed interval means every tablet in the venue hammers the server at
    // the exact same moment after a shared wifi blip.
    reconnect_base_interval: 1000,
    reconnect_max_interval: 20000,
    reconnect_attempts: 0,
    reconect: true,
    // Pending reliable (ack'd) sends: ackId -> retry timer.
    ack_pending: new Map(),
    ack_counter: 0,
    connect: function(host, port, callback) {
        // Guard against opening a second live socket while one is already
        // open/connecting (e.g. connect() firing twice) - that leaves the
        // server thinking there are two separate clients for the same tab,
        // one of them stuck as whatever role it had when it was abandoned.
        if(this.wso && (this.wso.readyState === WebSocket.OPEN || this.wso.readyState === WebSocket.CONNECTING)){
            callback();
            return;
        }
        //window.store.commit("setLoading", true);
        //window.router.push({name: "Loading"});
        window.store.commit("setNetwork", "connecting");

        let ws_url;
        // Tunnels (ngrok and friends) only expose one origin/port - there's
        // no separate host:port to point at like on a LAN or the real
        // production domain. See vue.config.js's devServer.proxy: the dev
        // server itself forwards /game-ws to the raw ws server on port 1337,
        // so connecting to "same origin + /game-ws" (protocol matched to
        // however the page itself was loaded) reaches it through that same
        // tunnel. Not "/ws" - that's webpack-dev-server's own HMR socket
        // path. Sibling: api.js's base_url() has the same same-origin branch.
        if(process.env.VUE_APP_WS_SAME_ORIGIN === 'true'){
            this.host = window.location.host;
            this.port = null;
            this.protocol = (window.location.protocol === 'https:') ? 'wss://' : 'ws://';
            ws_url = this.protocol + this.host + '/game-ws';
        }else{
            this.host = process.env.VUE_APP_HOST || window.location.host;
            this.port = process.env.VUE_APP_PORT;
            this.protocol = (process.env.NODE_ENV === 'development') ? 'ws://' : 'wss://';
            ws_url = this.protocol + this.host + ":" + this.port;
        }

        try{
            this.wso = new WebSocket(ws_url);
        }catch(ex){
            // A malformed ws_url (e.g. a stray ":undefined" port) throws
            // synchronously here instead of firing onerror/onclose - without
            // this it fails completely silently: network state gets stuck on
            // "connecting" forever with nothing in the console or the
            // Network tab to explain why. Surface it loudly instead.
            console.error("No se ha podido construir la conexión WebSocket:", ws_url, ex);
            window.toast.error("No se ha podido conectar (" + ex.message + ")");
            window.store.commit("setNetwork", "error");
            return;
        }
        window.wso= this.wso;
        if(network.reconnecting == true) {
            window.store.commit("setNetwork", "reconnecting");
            //window.store.commit("setLoading", true);
            //window.router.push({name: "Loading"});
        }
        this.wso.onopen = function(callback) {
            // A deploy restarts the server, so every open tab comes back
            // through here - the moment to notice it's running an old build.
            if(network.reconnecting)
                network.reload_if_outdated();
            network.reconnect_attempts = 0;
            window.store.commit("loadLocalStorage", null);
            window.store.commit("setNetwork", "connected");
            //window.store.commit("setLoading", false);
            // Register all RPC's
            network.register_rpc(window.RPC.CLIENT_JOIN, window.client.client_join);
            network.register_rpc(window.RPC.CLIENT_PING, window.client.client_ping);
            network.register_rpc(window.RPC.CLIENT_UPDATE, window.client.client_update);
            network.register_rpc(window.RPC.CLIENT_AUTH, window.client.client_auth);
            network.register_rpc(window.RPC.CLIENT_TOAST, window.client.client_toast);
            network.register_rpc(window.RPC.UPDATE_VIEW, window.client.update_view);
            network.register_rpc(window.RPC.CLIENT_CLEAN, window.client.client_clean);
            network.register_rpc(window.RPC.CLIENT_RELOAD, window.client.client_reload);
            network.register_rpc(window.RPC.EDIT_ACTIVITY, window.client.edit_activity);
            network.register_rpc(window.RPC.CLIENT_KICK, window.client.client_kick);
            network.register_rpc(window.RPC.CLIENT_RELOAD_ALL, window.client.client_reload);
            network.register_rpc(window.RPC.CLIENT_SYNC_HANDSHAKE, window.client.client_sync_handshake);
            network.register_rpc(window.RPC.SYNC_HANDSHAKE_INFO, window.client.sync_handshake_info);
            network.register_rpc(window.RPC.TIMER_STOP, window.client.timer_stop);
            network.register_rpc(window.RPC.SAVE_AVATAR, window.client.save_avatar);
            network.register_rpc(window.RPC.CANCEL_LAUNCH_ACTIVITY, window.client.cancel_launch_activity);
            network.register_rpc(window.RPC.CLIENT_DEBUG, window.client.client_debug);
            network.register_rpc(window.RPC.JOIN_CODE_RESULT, window.client.join_code_result);
            network.register_rpc(window.RPC.USERNAME_CHECK_RESULT, window.client.username_check_result);
            network.register_rpc(window.RPC.CLIENT_AUTH_RESULT, window.client.client_auth_result);
            network.register_rpc(window.RPC.SESSION_ALREADY_ACTIVE, window.client.session_already_active);

            // First sent packet after establish the connection with the server.
            wso.send(JSON.stringify({action: window.RPC.CLIENT_JOIN, params: {session:window.store.state.game.session, device: window.device, event_code: window.location.pathname.match(/^\/(?:join|login)\/([^/]+)/)?.[1]}}))
            callback();
        }.bind(this, callback);
        this.wso.onmessage = function(evt) {
            network.handle_message(evt)
        };
        this.wso.onclose = function(evt) {
            //window.store.commit("setLoading", true);
            //window.router.push({name: "Loading"});
            window.wso = null;
            network.reconnecting = true;
            // Don't clobber the explanation client.js's session_already_active()
            // just set - this close is that rejection playing out, not a real
            // network drop, and network.reconect is already false so nothing
            // below will retry anyway.
            if(window.store.state.network != 'session_conflict')
                window.store.commit("setNetwork", "disconnected");
            try{
                // NOT bound like onopen above - "this" here is the WebSocket
                // itself, not `network`, so this.reconect was always
                // undefined ("undefined == false" is false, never short-
                // circuiting). That silently made network.reconect = false
                // a no-op everywhere it's set (close(), session_already_active())
                // - this tab kept reconnecting anyway. Read it off `network`.
                if(network.reconect == false) return;

                const delay = Math.min(
                    network.reconnect_max_interval,
                    network.reconnect_base_interval * Math.pow(2, network.reconnect_attempts)
                );
                // +/-15% jitter so a wifi blip that drops many tablets at once
                // doesn't make them all retry in lockstep.
                const jitter = delay * 0.15 * (Math.random() * 2 - 1);
                network.reconnect_attempts++;

                setTimeout(function(){
                    network.connect(network.host, network.port, function(){})
                }, Math.max(network.reconnect_base_interval, delay + jitter));
            }catch(e){ console.log(e) }
        };
        this.wso.onerror = function(evt) {
            window.store.commit("setNetwork", "error");
        };
    },
    async reload_if_outdated(){
        if(!(await isOutdated()))
            return;
        if(typeof GameInterface !== 'undefined')
            GameInterface.GameReload("");
        else
            window.location.reload();
    },
    close()
    {
        this.reconect = false;
        this.wso.close();
    },
    register_rpc: function(rpcid, fn) {
        network.registered_rpcs[rpcid] = fn;
    },
    /**
     * Fire-and-forget send, for anything that's fine to lose if the socket
     * happens to be down at that exact instant (most of the protocol).
     */
    send: function(action, params) {
        if(!network.wso || network.wso.readyState !== WebSocket.OPEN)
            return;
        network.wso.send(JSON.stringify({action: action, params: params}));
    },
    /**
     * Send that must be acknowledged by the server (see RPC.ACK), retried on
     * timeout. Reserved for actions where silently losing the packet has a
     * real gameplay cost (e.g. submitting an answer) - using this for
     * everything would add overhead to the high-frequency, low-value traffic.
     *
     * @param   {[Number]}  action    RPC id.
     * @param   {[Object]}  params    RPC params.
     * @param   {[Object]}  options   Optional {timeout, retries, onFail}.
     */
    send_reliable: function(action, params, options) {
        options = options || {};

        // Online mode's player-facing flows never touch this websocket (see
        // client.js's client_update() gate) - UPDATE_ACTIVITY is the one RPC
        // the reused type/*.vue components (Quiz.vue, TrueFalse.vue, ...)
        // still send directly and unconditionally, so this is the single
        // choke point that redirects it to POST /api/answers instead,
        // without touching those six components at all.
        if(window.MODE == window.utils.APP_MODES.ONLINE && action == window.RPC.UPDATE_ACTIVITY){
            window.api.submit_answer(params.question, params.choice, params.timestamp)
                .then(function(result){
                    const online_user = window.store.state.online_user;
                    const clients = (window.store.state.game.clients || []).map(function(c){
                        if(!online_user || c.username != online_user.username)
                            return c;
                        const data = (c.data || []).filter((d) => d.question != params.question);
                        data.push({ question: params.question, choice: params.choice, timestamp: params.timestamp, locked: true });
                        return Object.assign({}, c, { data: data });
                    });
                    window.store.commit("setClients", clients);
                    window.store.commit("setLastOnlineAnswer", {
                        question_id: params.question,
                        choice: params.choice,
                        timestamp: params.timestamp,
                        correct: result.correct,
                        score: result.score
                    });
                })
                .catch(function(){
                    if(options.onFail) options.onFail();
                });
            return;
        }

        const timeout = (options.timeout != null) ? options.timeout : 3000;
        let retries_left = (options.retries != null) ? options.retries : 3;
        const ack_id = 'c' + Date.now().toString(36) + (network.ack_counter++).toString(36);
        const payload = JSON.stringify({ action: action, params: params, ack: ack_id });

        const attempt = function(){
            if(network.wso && network.wso.readyState === WebSocket.OPEN){
                network.wso.send(payload);
            }
            network.ack_pending.set(ack_id, setTimeout(function(){
                if(retries_left > 0){
                    retries_left--;
                    attempt();
                }else{
                    network.ack_pending.delete(ack_id);
                    if(options.onFail) options.onFail();
                }
            }, timeout));
        };

        attempt();
    },
    /**
     * Clears the retry timer for a reliable send once the server confirms
     * receipt with an RPC.ACK message.
     */
    resolve_ack: function(ack_id) {
        const timer = network.ack_pending.get(ack_id);
        if(timer != null){
            clearTimeout(timer);
            network.ack_pending.delete(ack_id);
        }
    },
    handle_action : function(rpc, params) {
        if(rpc === window.RPC.ACK){
            network.resolve_ack(params && params.ack);
            return;
        }
        if(this.registered_rpcs[rpc])
            this.registered_rpcs[rpc](params);
    },
    handle_message: function(message) {
        try {
            //ws, rpc, params
            const msg = JSON.parse(message.data);
            network.handle_action(msg.action, msg.params);

            // Mirror the server: acknowledge any inbound message tagged with an
            // ack id, right after dispatch.
            if(msg.ack != null && network.wso && network.wso.readyState === WebSocket.OPEN){
                network.wso.send(JSON.stringify({action: window.RPC.ACK, params: {ack: msg.ack}}));
            }
        } catch(error) {
            console.error(error)
        }
    }
};

export default network;